import { render, staticRenderFns } from "./InputDocumentos.vue?vue&type=template&id=07cacbe8&scoped=true&"
import script from "./InputDocumentos.vue?vue&type=script&lang=js&"
export * from "./InputDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./InputDocumentos.vue?vue&type=style&index=0&id=07cacbe8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cacbe8",
  null
  
)

export default component.exports